module.exports = __webpack_public_path__ + "img/viewpoint-animate1.46ae307e.png";